


























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import { TweenLite } from 'gsap';

import { $eventBus } from '@/eventBus';

import { VideoClickableRect, VideoClickPosition } from '../../types/VideoTypes';

class Position implements VideoClickPosition {
  x = 0;
  y = 0;
  constructor(x: number = 0, y: number = 0) {
    this.x = x;
    this.y = y;
  }
}

const clickAnimationLength = 0.5;

// TODO STOP ANIMATION ON HIDE! / RESET ANIMATION ON NEW STEP!
// CURENTLY RAPID PAUSE AND PLAY FIRES SIMOUNTANIOUS CLICKS ETC
// CURENTLY SELECTING NEW STEPS DOES FIRE SIMOUNTANIOUS CLICKS ETC

@Component
export default class ProcessVideoCursor extends Vue {
  @Prop() clickPosition!: VideoClickPosition;
  @Prop() viewBox!: SVGAnimatedRect;
  @Prop() cursorAnimationTime!: number;

  tween!: object; // TWEEN?

  cursorTranslate: string = this._makeTranslate(new Position());
  targetPosition: Position = new Position();
  cursorPositon: Position = new Position();
  posX: number = 0;
  posY: number = 0;
  circleRadius: number = 0;
  circleOpacity: number = 0;

  @Watch('clickPosition', { deep: true })
  onClickPositionChanged() {
    this._setTargetPosition();
    // this.animatePosition();
  }
  @Watch('viewBox', { deep: true })
  onViewBoxChanged() {
    this._setTargetPosition();
  }

  @Watch('posX')
  onPosXChanged() {
    const position = new Position();
    position.x = this.posX;
    position.y = this.posY;
    this.cursorTranslate = this._makeTranslate(position);
  }
  _setTargetPosition(): void {
    if (this.clickPosition && this.viewBox) {
      this.targetPosition.x =
        this.clickPosition.x / 100 * this.viewBox.baseVal.width;
      this.targetPosition.y =
        this.clickPosition.y / 100 * this.viewBox.baseVal.height;
    }
  }
  _makeTranslate(pos: Position): string {
    return 'translate(' + pos.x + ',' + pos.y + ')';
  }

  _setCurrentPosition(): void {
    this.cursorPositon.x = this.posX;
    this.cursorPositon.y = this.posY;
  }
  animatePosition(): void {
    // TODO OPTIMIZE TWEEN. CURRENT STATUS -> HACKY
    this._setCurrentPosition();

    const fromX = this.cursorPositon.x;
    const fromY = this.cursorPositon.y;
    const toX = this.targetPosition.x;
    const toY = this.targetPosition.y;

    this.tween = TweenLite.fromTo(
      this.$data,
      this.cursorAnimationTime,
      {
        posY: fromY,
        posX: fromX,
      },
      {
        posY: toY,
        posX: toX,
        onComplete: this._setCurrentPosition,
      },
    );
  }
  animateClick(): void {
    TweenLite.fromTo(
      this.$data,
      clickAnimationLength,
      {
        circleRadius: 0,
        circleOpacity: 1,
      },
      {
        circleRadius: 35,
        circleOpacity: 0,
      },
    );
  }
  mounted(): void {
    $eventBus.$on('animateCursorClick', this.animateClick);
    $eventBus.$on('animateCursorPosition', this.animatePosition);
  }
  beforeDestroy(): void {
    $eventBus.$off('animateCursorClick', this.animateClick);
    $eventBus.$off('animateCursorPosition', this.animatePosition);
  }
}
